const STORAGE_KEY = 'app_source'

export function detectAndSaveSource() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  const referrer = document.referrer || ''
  const isClearlyBrowser = !isStandalone && !referrer.startsWith('android-app://')

  if (isClearlyBrowser) {
    localStorage.setItem(STORAGE_KEY, 'browser')
    return 'browser'
  }

  localStorage.setItem(STORAGE_KEY, 'twa')
  return 'twa'
}

export function isTWA() {
  return detectAndSaveSource() === 'twa'
}